import { useHistory } from "react-router-dom";
import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import { Stack,CircularProgress } from '@mui/material';
import moment from "moment";
const ExcelJS = require('exceljs');
var loggedIn = true;
var lastLoggedIn = null;
var debugMode = false;
export var permissions = null;

export function LoginUser(Username, Password) {
	let urlHostName = 'localhost:1337';
	if (USE_HOSTNAME == "true") {
		urlHostName = window.location.host
	}
	fetch("/api/SignIn", {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			"Email": Username + "@us.beyondsoft.com",
			"Password": Password
		})
	}).then((response) => {
		if (response.ok) {
			// alert('Logged in successfully');
			window.location.hash = '#/Home';
			window.location.reload();
			return response.json();
		}
		return response.json().then((body) => {
			throw new Error(body.error);
		})
	}).then(json => console.log(json))
		.catch((error) => {
			alert(error.message);
		});
}

export function dateTransformation(date) {
	var dateArray = date.split("/");
	return dateArray[2] + "-" + dateArray[0] + "-" + dateArray[1];
}


async function fetchDebugMode() {
	try {
		const response = await fetch('/api/User/Permission');
		const data = await response.json();
		permissions = data;
		debugMode = data.DebugMode;
		//console.log("debug mode from permission", debugMode);
	} catch (error) {
	}
}

//fetchDebugMode function to set the initial value of debugMode
fetchDebugMode();

// Logger function
export function logger(...msg) {
	if (debugMode) {
		msg.forEach(arg => console.log(arg));
	}
}

export function handleExport({ rows, headers, filename, add_date = true, columnIndexToRemove = null, numberOfColumnsToRemove = null }) {
	if (columnIndexToRemove !== null) {
		if (numberOfColumnsToRemove !== null) {
			headers.splice(columnIndexToRemove, numberOfColumnsToRemove);
		} else {
			headers.splice(columnIndexToRemove, 1);
		}
	}
	const workbook = new ExcelJS.Workbook();
	const worksheet = workbook.addWorksheet('Sheet 1');

	const headerRow = worksheet.addRow(headers);
	headerRow.font = { bold: true };

	rows.forEach(row => {
		const newRow = worksheet.addRow(Object.values(row));
		//console.log("newRow", newRow);

		worksheet.columns.forEach(col => {
			const headerLength = col.headers.length;
			var maxColumnWidth = col.values.reduce((maxWidth, value) => {
				if (value && value.length > maxWidth) {
					return value.length;
				}
				return maxWidth;
			}, 0);
			if(maxColumnWidth>40){
				maxColumnWidth=40
			}
			col.width = Math.max(headerLength, maxColumnWidth)+2;
			col.alignment={ vertical: 'top', horizontal: 'left', wrapText: true }
		});
	});

	const currentDate = moment.utc().format("yyyy-MM-DD");
	// Generate the Excel file
	workbook.xlsx.writeBuffer().then(buffer => {
		const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = add_date ? (currentDate + "_" + filename || currentDate + '_' + 'datatable.xlsx')
			: (filename || 'datatable.xlsx');
		a.click();
	});
}

export function customBodyForExcelReport({ data, headers, columnIndexToRemove = null, numberOfColumnsToRemove = null }) {
	if (columnIndexToRemove !== null) {
		if (numberOfColumnsToRemove !== null) {
			headers.splice(columnIndexToRemove, numberOfColumnsToRemove);
		} else {
			headers.splice(columnIndexToRemove, 1);
		}
	}
	var choices = [];
	data.forEach(eachData => {
		if (columnIndexToRemove !== null) {
			if (numberOfColumnsToRemove !== null) {
				eachData.data.splice(columnIndexToRemove, numberOfColumnsToRemove);
			} else {
				eachData.data.splice(columnIndexToRemove, 1);
			}
		}
		//console.log("each", eachData);
		var combinedData = {};

		for (var i = 0; i < headers.length; i++) {
			var head = headers[i];
			var value = eachData.data[i];
			combinedData = {
				...combinedData
			};
			combinedData[head] = value;
		}

		choices.push(combinedData);
	});

	return choices;
}

function checkLastLoggedInTime(lastLoggedInTime) {
	if ((new Date().valueOf() - lastLoggedInTime) / 1000 < 3600) {
		return false;
	} else {
		return true;
	}
}

export function muiLoaderOptions(options, isLoading){
	const opt = {
		...options,
		textLabels: {
			toolbar: {
				search: "Search",
				downloadCsv: "Download Excel",
				print: "Print",
				viewColumns: "View Columns",
				filterTable: "Filter Table",
			},
			body: {
				noMatch: isLoading ? (
					<Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
						<Stack spacing={4} direction="row" justifyContent="center" display={'flex'}>
							<CircularProgress color="secondary" />
						      <CircularProgress color="success" />
						      <CircularProgress color="inherit" />
		                    </Stack>
		                  </Box>
		                ) : (
		                  "No matching records found"
		                )
		              }
		            }
		           
		          }
		          
  return opt;
}

export function muiLoaderOptionsWithoutLoading(options) {
	const opt = {
		...options,
		textLabels: {
			toolbar: {
				search: "Search",
				downloadCsv: "Download Excel",
				print: "Print",
				viewColumns: "View Columns",
				filterTable: "Filter Table",
			},
			body: {
				noMatch: (
					"No matching records found"
				)
			}
		}

	}

	return opt;
}

export function muiLoaderOptionsWithoutMUIDataTable(){
    return (
          <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Stack  spacing={4} direction="row" justifyContent="center" display={'flex'}>
              <CircularProgress color="secondary" />
		      <CircularProgress color="success" />
		      <CircularProgress color="inherit" />
            </Stack>
          </Box>
	);
}

export function checkAuthentication() {
	var logged = checkLastLoggedInTime(lastLoggedIn);
	//logger("lastLoggedIn=", lastLoggedIn);
	//logger("logged=", logged);
	if (loggedIn && logged) {
		fetch('/api/checkAuth')
			.then(res => {
				if (res.status === 200) {
					lastLoggedIn = new Date().valueOf();
					return true;
				} else {
					fetch('/api/Logout')
						.then(res => {
							if (res.ok) {
								//alert("Logged out succesfully");
								window.location.reload();
							}
						})
					loggedIn = false;
					return false;
				}
			})
	} else {
		return true;
	}
}